import React from 'react'

export default function NotFound() {
    return (
        <div className="w-full flex text-center flex-col mt-8 lg:mt-0 md:min-h-[100vh] items-center justify-center">
            <h2 className='text-5xl font-forum text-main-green'>Грешка 404</h2>
            <p className='text-body my-4'>Страницата, която се опитвате да посетите не съществува</p>
            <a href="/" className='underline font-bold text-main-gold'>Към началната страница</a>
        </div>
    )
}